var map = {
	"./clutch.png": 2202,
	"./displacement.png": 1148,
	"./down-chevron.png": 5983,
	"./drive-shaft.png": 4870,
	"./fuel-tank.png": 9740,
	"./net-power.png": 2540,
	"./tray-size.png": 7351,
	"./up-chevron.png": 5620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;